import Link from 'next/link';
import {CompanyLogo} from 'iq-interview_guides/components/company_logo';
import {TopicPillTag} from 'iq-questions/components/topic_pilltag';
import {LevelPillTag} from 'iq-questions/components/level_pilltag';
import {DotSeparator} from 'common/components/dot_separator';
import {timeSince} from 'common/utils';
import type {RecencyFeedItem} from 'iq-companies/types';

// "Recently asked" card — ported from the dashboard feed's RecencyFeedCard, reusing the real
// TopicPillTag/LevelPillTag components (iq-questions) as-is rather than reimplementing them.
export function RecencyFeedCard({item}: {item: RecencyFeedItem}) {
  return (
    <Link
      href={`/questions/${item.question_slug}`}
      className='block rounded-xl border border-gray-200 bg-white p-5'>
      <div className='flex flex-wrap items-center gap-2 text-xs'>
        <span className='font-semibold uppercase tracking-wide text-iq-orange'>
          Recently Asked Question
        </span>
        <DotSeparator className='text-gray-300' />
        <CompanyLogo
          companyWebsite={item.company_website}
          companyName={item.company_name}
          size={16}
          className='rounded object-contain'
        />
        <span className='font-medium text-gray-700'>{item.company_name}</span>
        <DotSeparator className='text-gray-300' />
        <span className='text-gray-500'>recently asked {timeSince(item.recently_used_at)}</span>
      </div>
      <p className='mt-2 font-semibold text-gray-900'>{item.question_title}</p>
      {item.question_summary && (
        <p className='mt-1 line-clamp-2 text-sm text-gray-600'>{item.question_summary}</p>
      )}
      <div className='mt-3 flex items-center gap-2'>
        <TopicPillTag name={item.question_topic} />
        <LevelPillTag level={item.question_level} />
      </div>
    </Link>
  );
}
